import React from 'react';
import { observer } from 'mobx-react';
import { IAddressProps } from './index';

export const AddressCountriesFormat = observer((props: IAddressProps) => {
  const { addressInputs } = props;

  return (
    <div>
      {addressInputs.addressInput}
      {addressInputs.secondAddressInput}
      <div className={'container-two-columns'}>
        {addressInputs.cityInput}
        {addressInputs.stateTextInput}
      </div>
      <div className={'container-two-columns'}>
        {addressInputs.zipCodeInput}
        {addressInputs.countryInput}
      </div>
    </div>
  );
});
